import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  useGetPermissionsApi,
  useGetProfileApi,
  useGetRolesApi,
} from '../api';
import { setPermissions, setProfile, setRoles } from 'src/modules/profile/slices';

export const useGetPermissionsService = () => {
  const dispatch = useDispatch();
  const getPermissionsApi = useGetPermissionsApi();

  return useCallback(async (companyId: string) => {
    try {
      const permissionsResponse = await getPermissionsApi({ companyId });
      dispatch(setPermissions(permissionsResponse.data.permissions));
    } catch (e) {
      console.log(e);
      throw e;
    }
  }, []);
};

export const useGetProfileService = () => {
  const dispatch = useDispatch();
  const getProfileApi = useGetProfileApi();

  return useCallback(async (companyId: string) => {
    try {
      const profileResponse = await getProfileApi({ companyId });
      dispatch(setProfile(profileResponse.data));
      return profileResponse.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }, []);
};

export const useGetRolesService = () => {
  const dispatch = useDispatch();
  const getRoles = useGetRolesApi();

  return useCallback(async () => {
    try {
      const rolesResponse = await getRoles();
      dispatch(setRoles(rolesResponse.data));
    } catch (e) {
      console.log(e);
      throw e;
    }
  }, []);
};
